/* vortex-allow-color-file: color palette picker — swatches are user-selectable literal colors (data), not theme styling. */
import { categoryColors } from "@plasma/data/categories";
import { twJoin } from "tailwind-merge";

import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

type ColorName = (typeof categoryColors)[number];

/* Color mapping to design system semantic colors */
const colorClasses: Record<ColorName, string> = {
  white: "bg-background border-border",
  gray: "bg-muted border-border",
  red: "bg-destructive/10 border-destructive",
  orange: "bg-warning/10 border-warning",
  amber: "bg-warning/15 border-warning",
  yellow: "bg-warning/20 border-warning",
  lime: "bg-success/10 border-success",
  green: "bg-success/15 border-success",
  emerald: "bg-success/20 border-success",
  teal: "bg-info/15 border-info",
  cyan: "bg-info/10 border-info",
  sky: "bg-sky-100 border-sky-300",
  blue: "bg-sky-200 border-sky-400",
  indigo: "bg-sky-300 border-sky-500",
  violet: "bg-sky-400 border-sky-600",
  purple: "bg-sky-400 border-sky-600",
  fuchsia: "bg-sky-300 border-sky-500",
  pink: "bg-sky-200 border-sky-400",
};

export const ColorSelector = ({
  children,
  onValueChange,
}: {
  children: React.ReactNode;
  onValueChange: (value: ColorName) => void;
}) => (
  <Popover>
    <PopoverTrigger asChild>{children}</PopoverTrigger>
    <PopoverContent className="-mt-7 w-full p-2">
      <div className="grid grid-cols-6 gap-1">
        {categoryColors.map((color) => (
          <Button
            className="size-auto rounded-xl p-2"
            key={color}
            onClick={() => onValueChange(color)}
            type="button"
            variant="ghost"
          >
            <ColorCircle color={color} />
          </Button>
        ))}
      </div>
    </PopoverContent>
  </Popover>
);

const ColorCircle = ({ color }: { color: ColorName }) => (
  <div className={twJoin("size-13 rounded-full border", colorClasses[color])} />
);
